import React from 'react';
import * as S from './ThingsYouShouldKnow.styles';
import MegaPhoneIcon from '../../../../Icons/MegaPhoneIcon';

const ThingsYouShouldKnow: React.FC<{list: Array<string>}> = ({list = []}) => {
  if (!list.length) {
    return null;
  }

  return (
    <S.ThingsYouShouldKnowWrapper>
      <S.TitleOuterWrapper>
        <MegaPhoneIcon />
        <S.TitleWrap>Things you should know</S.TitleWrap>
      </S.TitleOuterWrapper>
      <S.ThingsListItem>
        {list.map(item => (
          <li>{item}</li>
        ))}
      </S.ThingsListItem>
    </S.ThingsYouShouldKnowWrapper>
  );
};

export default ThingsYouShouldKnow;
